import { render, staticRenderFns } from "./GeneralElectricalDevice.vue?vue&type=template&id=b2521a82&scoped=true&"
import script from "./GeneralElectricalDevice.vue?vue&type=script&lang=js&"
export * from "./GeneralElectricalDevice.vue?vue&type=script&lang=js&"
import style0 from "./GeneralElectricalDevice.vue?vue&type=style&index=0&id=b2521a82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2521a82",
  null
  
)

export default component.exports